import Uppy from '@uppy/core';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import { validateFileUpload } from '../../../../utils/validateFileUpload/fileValidation';

export const MAX_FILE_SIZE_MB = 100;

export const createUppy = ({ id }: { id: string }) => {
  const uppy = new Uppy({
    id,
    autoProceed: false,
    restrictions: {
      maxFileSize: 1024 ** 2 * MAX_FILE_SIZE_MB,
      minNumberOfFiles: 1,
      maxNumberOfFiles: 10,
    },
    onBeforeFileAdded: (currentFile) => {
      try {
        validateFileUpload({
          filename: currentFile.name,
          mimeType: currentFile.type,
        });
        return currentFile;
      } catch (error) {
        uppy.emit('restriction-failed', currentFile, error as Error);
        return false;
      }
    },
  });

  uppy.use(ThumbnailGenerator, {
    thumbnailWidth: 100,
    thumbnailHeight: 80,
    waitForThumbnailsBeforeUpload: true,
  });

  return uppy;
};
